module.exports = __webpack_public_path__ + "img/lagerausbildung-4bohrungen.5a64ff30.jpg";